// Enum-like object for MessageType
const MessageType = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  FILE: "FILE",
  SYSTEM: "SYSTEM",
};

class WebChatMessage {
  constructor() {
    // Message unique identifier
    this.messageId = null;

    // Message content type
    this.type = null;

    // Sender information
    this.sender = null;
    this.senderId = null;
    this.senderName = null;

    // Message content
    this.content = null;

    // File-related properties
    this.fileUrl = null;
    this.fileInfo = null;

    // Timestamp
    this.timestamp = null;

    // Additional communication properties
    this.callType = null;
    this.to = null;
    this.from = null;
    this.source = null;
  }

  // FileInfo inner class
  static FileInfo = class {
    constructor() {
      this.fileName = null;
      this.fileType = null;
      this.fileSize = null;
    }
  };

  // Utility method to create text message
  static createTextMessage(
    messageId,
    phone,
    officeDid,
    senderId,
    senderName,
    content,
    source
  ) {
    const message = new WebChatMessage();
    message.type = MessageType.TEXT;
    message.senderId = senderId;
    message.sender = "Customer";
    message.senderName = senderName;
    message.content = content;
    message.callType = "Website";
    message.phone = phone;
    message.to = officeDid;
    message.from = phone;
    message.messageId = messageId;
    message.source = source ?? "Tax";
    return message;
  }

  static createFileMessage(
    phone,
    officeDid,
    senderId,
    senderName,
    fileInfo,
    source
  ) {
    const message = new WebChatMessage();
    message.type = MessageType.FILE;
    message.senderId = senderId;
    message.sender = "Customer";
    message.senderName = senderName;
    message.content = "";
    message.callType = "Website";
    message.phone = phone;
    message.to = officeDid;
    message.from = phone;
    message.messageId = "123";
    message.fileInfo = fileInfo;
    message.source = source ?? "Tax";
    return message;
  }

  // Determine file type based on file name
  static determineFileType(fileName) {
    if (!fileName) return MessageType.FILE;

    const lowerFileName = fileName.toLowerCase();
    const imageExtensions = [".png", ".jpg", ".jpeg", ".gif", ".bmp"];

    if (imageExtensions.some((ext) => lowerFileName.endsWith(ext))) {
      return MessageType.IMAGE;
    }

    return MessageType.FILE;
  }
}

// Export the class and MessageType for use in other modules
export { WebChatMessage, MessageType };
